var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@patternfly/react-core';
import { ExternalLinkAltIcon } from '@patternfly/react-icons';
import { forwardRef } from 'react';
;
export const ExternalLinkButton = forwardRef((_a, ref) => {
    var { iconProps } = _a, props = __rest(_a, ["iconProps"]);
    return (_jsx(Button, Object.assign({ component: "a", icon: _jsx(ExternalLinkAltIcon, Object.assign({}, iconProps)), iconPosition: "right", ouiaId: "ExternalLinkButton", ref: ref, rel: "noopener noreferrer", target: "_blank" }, props)));
});
export default ExternalLinkButton;
